// extracted by mini-css-extract-plugin
export default {"root":"_1kfoD","content":"_2-yY9","payment":"_3Len9"};